import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import campusobs1 from "../../assets/Images/campusobs/campusobs1.jpg";
import campusobs2 from "../../assets/Images/campusobs/campusobs2.jpg";
import campusobs3 from "../../assets/Images/campusobs/campusobs3.jpg";
import campusobs4 from "../../assets/Images/campusobs/campusobs4.jpg";
import campusobs5 from "../../assets/Images/campusobs/campusobs5.jpg";
import campusobs6 from "../../assets/Images/campusobs/campusobs6.jpg";
import campusobs7 from "../../assets/Images/campusobs/campusobs7.jpg";
import campusobs8 from "../../assets/Images/campusobs/campusobs8.jpg";

import pixelobs1 from "../../assets/Images/pixelobs/pixelobs1.jpg";
// import pixelobs2 from "../../assets/Images/pixelobs/pixelobs2.jpg";
import pixelobs3 from "../../assets/Images/pixelobs/pixelobs3.jpg";
import pixelobs4 from "../../assets/Images/pixelobs/pixelobs4.jpg";
import pixelobs5 from "../../assets/Images/pixelobs/pixelobs5.jpg";
import pixelobs6 from "../../assets/Images/pixelobs/pixelobs6.jpg";










import pixelobsm1 from "../../assets/Images/pixelobs/pixelobs1.mp4";
import pixelobsm2 from "../../assets/Images/pixelobs/pixelobs3.mp4";
import pixelobsm3 from "../../assets/Images/pixelobs/pixelobs2.mp4";
import pixelobsm4 from "../../assets/Images/pixelobs/pixelobs5.mp4";

import field1 from "../../assets/Images/fieldpics/field1.jpg";
import fieldm1 from "../../assets/Images/fieldpics/field1.mp4";




import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";






import Slideshow from "../../assets/Slideshow/Slideshow"; 




const Lo4Res = () => {
    const navigate = useNavigate();

    const images = [campusobs1, campusobs2, campusobs3, campusobs4, campusobs5, campusobs6, campusobs7, campusobs8];

    const images2 = [pixelobs1, pixelobs3, pixelobs4, pixelobs5, pixelobs6, pixelobsm1, pixelobsm2, pixelobsm3, pixelobsm4]

    const images3 = [field1, fieldm1]
    
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Research Question & Methods</h1>
                <p>I need to show how I create research plan with clear question and techniques</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
                        </div>
                        
            <div className="content-lo4">
                <div className="content-lo4-research">
                    <div className="content-lo4-research-text">
                    {/* <img src={gif2}></img> */}
                        <h1>Observation on the campus</h1>
                        <p>
                            For the observation phase, we use CMD methods to examine how people interact with different forms of media and 
                            products in our daily life, Together with my groupmate Adib and I conducted a field observation around the campus 
                            to get inspiration for our client project.
                        </p>
                        <p>
                            Our goal was to identify different types of marketing startegies our campus is using, by paying attention to posters,
                            visual's design, some objects, and wallpaper across the campus analyzing how they were place and how effectively they
                            captured students attention.
                        </p>
                        <p>
                            From this observation, I learned that engagement happensthrough a mix of craetivity, accessibility, and interaction.
                            Effective campus visuals often combine bold graphics, easy to scan messages, and interactive elements like QR code.
                            This directly influenced how I approach the design for our marketing products, to not only be seen but also expirenced.
                        </p>

                        
                        
                    </div>

                    <div className="content-lo4-research-text2">
                        <h1>Observation on Pixel Playground</h1>
                        <p>
                            I also did a research for our client project to better understand bothe the client and the field of virtual production.
                            As part of this research, my group leader Adib arranged a visit to the Pixel Playground.
                        </p>
                        <p>
                            During this observation I found out that:
                            <ul>
                                <li>Pixel Playground doesn't use green screen, this studio basically use LED Display</li>
                                <li>It is better than using green screen</li>
                                <li>It has 4K Resollution</li>
                                <li>Refresh rate for the display is high</li>
                                <li>Not all campus would do this for film making in the Netherlands</li>
                                <li>Students can use their own models/scene using blender</li>
                                <li>Students can learn film making with an expensive equipment</li>
                            </ul>
                            I now have a much better idea of what makes Pixel Playground an asset for Fontys overall as well as for students who want to
                            work in digital media and virtual production. It is one of the most well-equipped film production studios in the Netherlands
                            education because of its advanced technology, experiential learning opportunities, and open creative environment. 
                            This information will enable us to modify our marketing approach in order to emphasize these advantages and convince potential students of the new minor's worth.

                            


                            
                        </p>
                        
                    </div>

                    <div className="content-lo4-research-text3">
                        <h1>Field Research During Market Display</h1>
                        <p>
                            We took part in a Display Event as part of our project, where all third-semester students displayed the work they had done on client
                            assignments. Our groupmate Adib and I demonstrated our interactive 3D poster at this event, which was made to play cat sound as soon
                            as someone passed it. This feature was successful in drawing attention because a number of students paused to look at the poster, and
                            some teachers even commented on how captivating it was.
                             
                        </p>
                        <p>
                            I included a QR code that takes people straight to the Fontys Pixel Playground website in order to further tie the poster to our client's objective.
                            We noticed that some interested students and our client representatives scanned the code to find out more information about the studio.
                        </p>
                        <p>
                            Overall, this event served as a valuable field research opportunity, helping me validate that our concept was not only creative and technically functional
                            but also effective in sparking engagement.
                        </p>
                    </div>

                    <div className="content-lo4-research-slideshow">
                        <Slideshow images={images} />

                    </div>

                    <div className="content-lo4-research2-slideshow">
                        <Slideshow images={images2} />

                    </div>

                    <div className="content-lo4-research3-slideshow">
                        <Slideshow images={images3} />

                    </div>
                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo4Res;